import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface AlertRowProps {
  icon: ReactNode;
  title: string;
  description: string;
  /** Sağdaki sayaç — `Badge tone="neutral"` beklenir. */
  count: ReactNode;
  /**
   * Satırın tamamı bir bağlantı değil (bkz. `ListRow` — aynı gerekçe): çağıran isterse
   * tıklanabilir yapmak için satırı kendi `<Link>`'ine sarar.
   */
  onClick?: () => void;
  className?: string;
}

/**
 * Uyarı satırı — mockup Ana Sayfa "Önemli Uyarılar".
 *
 * ⚠ Ton her zaman `warning` ailesi — kart: uyarı hukuki bir hüküm değil (CLOS-182),
 * bu yüzden `tone` prop'u YOK; renk seçimi bu bileşenin sorumluluğunda değil, sabit.
 */
export function AlertRow({ icon, title, description, count, onClick, className }: AlertRowProps) {
  const content = (
    <>
      <span
        aria-hidden="true"
        className="flex size-9 shrink-0 items-center justify-center rounded-md bg-warning-soft text-warning [&_svg]:size-[18px]"
      >
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <span className="block truncate text-sm font-semibold text-fg-strong">{title}</span>
        <span className="block truncate text-[13px] text-fg-muted">{description}</span>
      </div>
      <span className="shrink-0">{count}</span>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(
          "flex h-16 w-full items-center gap-3 rounded-lg border border-border-subtle px-3.5 text-left transition-colors hover:bg-muted",
          className,
        )}
      >
        {content}
      </button>
    );
  }

  return (
    <div
      className={cn(
        "flex h-16 items-center gap-3 rounded-lg border border-border-subtle px-3.5",
        className,
      )}
    >
      {content}
    </div>
  );
}
